import React from 'react'
import cardOne from './Images/rowTwo/cardFour.jpg'
import cardTwo from './Images/rowTwo/cardFive.jpg'
import cardThree from './Images/rowTwo/cardSix.jpg'
export default function WhatWeDo() {
    return (
        <div className='py-5' style={{}}>
        
            <h1 style={{ color: "#A10302",fontWeight:'bold'}} className="text-center mb-5">What We Do</h1>
            
                  <div >
          
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"white",borderRadius:'0px'}} class="card">
                            <img src={cardOne} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'white'}} class="card-body">
                                <h5 class="card-title">House Renovation</h5>
                                <p class="card-text">Constructor explains how you can enjoy high end flooring trends like textured...</p>
                                <a style={{color:'#A10302'}} href="#" >READ MORE</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"white",borderRadius:'0px'}} class="card">
                            <img src={cardTwo} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'white'}} class="card-body">
                                <h5 class="card-title">The Effective Teamwork</h5>
                                <p class="card-text">As the general contractor, we first create the highest level of trust and integrity with our clients...</p>
                                <a style={{color:'#A10302'}} href="#" >READ MORE</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"white",borderRadius:'0px'}} class="card">
                            <img src={cardThree} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'white'}} class="card-body">
                                <h5 class="card-title">The Green Building</h5>
                                <p class="card-text">Green construction refers to a structure and using process that is environmentally responsible...</p>
                                <a style={{color:'#A10302'}} href="#" >READ MORE</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/services copy 2.jsx